"use strict";

function filterByText(pois, text) {
	return pois.filter(poi => {
		
		const pattern = new RegExp(text, "i");
		
		if (poi.name && pattern.test(poi.name))
			return true;
		if (poi.address && pattern.test(poi.address))
			return true;
		return false;
	});
}

function filterByType(pois, type) {
	
	return pois.filter(poi => {
		
		if(poi.type == type){
			return true;
		}
		else{
			return false;
		}
		
	});
}

export default function filterPOIs(pois, expression) {
	if (!pois || (expression.text == "" && !expression.type))
		return null;
	
	let filteredPOIs = pois.slice();
	
	if (expression.text)
		filteredPOIs = filterByText(filteredPOIs, expression.text);
	
	if (expression.type)
		filteredPOIs = filterByType(filteredPOIs, expression.type);
	
	return filteredPOIs;
}


// WEBPACK FOOTER //
// ./src/view/POIList/filterPOIs.js